module.exports = __webpack_public_path__ + "img/1.53315b93.png";